<template>
  <el-select   filterable clearable @change="handleChange" :value="data" :placeholder="$t('请选择')" :disabled="disabled" >
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in list" :key="index"></el-option>
  </el-select>
</template>

<script>
import { getCascade } from "@/services/deviceType";

export default {
  name: "OperatorSelect",
  props: {
      value:{
        },
        disabled:{
            type:Boolean,
            default:false
        },

  },
  watch: {
    value: {
      immediate: true,
      handler: function(value) {
        this.data=value;
      }
    }
  },
  data() {
    return {
      data: "",
      list: []
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    handleChange(value) {
      this.data = value;
      this.$emit("input", value);
    },
      getName(value){
        let find=  this.list.find(item=>item.value==value);
        return find.name;
      },
    async loadData() {
      const response = await getCascade({});
    if (response) {
        this.list = response.data.operatorName.map((item, i) => {
          return { name: item.operatorName, value: item.operatorName };
        });
      }
    }
  }
};
</script>

<style scoped>
.el-select{
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/PropsSelect/OperatorSelectByName.vue